import { useMemo } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

export interface ChartThemeColors {
  primary: string;
  primaryLight: string;
  text: string;
  grid: string;
  tooltipBg: string;
  tooltipBorder: string;
  tooltipText: string;
  activeDotStroke: string;
  success: string;
  error: string;
  info: string;
  warning: string;
}

const DARK_CHART: ChartThemeColors = {
  primary: '#D4A574',
  primaryLight: 'rgba(212, 165, 116, 0.15)',
  text: '#71717a',
  grid: '#333333',
  tooltipBg: '#1a1a1a',
  tooltipBorder: '#333333',
  tooltipText: '#ffffff',
  activeDotStroke: '#18181b',
  success: '#22c55e',
  error: '#ef4444',
  info: '#3b82f6',
  warning: '#f59e0b',
};

const LIGHT_CHART: ChartThemeColors = {
  primary: '#A07A50',
  primaryLight: 'rgba(160, 122, 80, 0.12)',
  text: '#6b7280',
  grid: '#DDD8D0',
  tooltipBg: '#ffffff',
  tooltipBorder: '#DDD8D0',
  tooltipText: '#1A1715',
  activeDotStroke: '#ffffff',
  success: '#16a34a',
  error: '#dc2626',
  info: '#2563eb',
  warning: '#d97706',
};

export function useChartTheme(): ChartThemeColors {
  const { resolvedTheme } = useTheme();
  return useMemo(() => resolvedTheme === 'dark' ? DARK_CHART : LIGHT_CHART, [resolvedTheme]);
}
